export class GeneralInput {
    constructor(domElement) {
        this.domElement = domElement;
        this.modifiers = [];
    }
    hasName() {
        return this.name !== undefined;
    }
    get jQueryObject() {
        return $(this.domElement);
    }
    get name() {
        return this.jQueryObject.attr("name");
    }
    get value() {
        return this.jQueryObject.val();
    }
    executeNextModifiers(formData, currentIndex, onFinished) {
        if (currentIndex === this.modifiers.length) {
            onFinished();
            return;
        }
        this.modifiers[currentIndex]
            .prepareValue(formData, this.name)
            .then((value) => {
            this.executeNextModifiers(formData, currentIndex + 1, onFinished);
        });
    }
    set disabled(value) {
        this.jQueryObject.prop("disabled", value);
    }
    get disabled() {
        return this.jQueryObject.prop("disabled");
    }
    addToFormData(formData) {
        return new Promise((resolve) => {
            const { value } = this;
            if (value !== undefined) {
                formData.set(this.name, value);
            }
            this.executeNextModifiers(formData, 0, resolve);
        });
    }
    addModifier(modifier) {
        if (!this.jQueryObject.is(modifier.selector)) {
            return;
        }
        this.modifiers.push(modifier);
        modifier.input = this;
    }
}
